export class KeyLocation {
}
KeyLocation.STANDARD = 0;
KeyLocation.LEFT = 1;
KeyLocation.RIGHT = 2;
KeyLocation.NUM_PAD = 3;
